import React, { createContext, useContext } from 'react';
import { useFocusFieldByProperty } from './useFocusFieldByProperty';

const FieldRefContext = createContext(null);

export const FieldRefProvider = ({ children }) => {
  const focusFieldHook = useFocusFieldByProperty();

  return <FieldRefContext.Provider value={focusFieldHook}>{children}</FieldRefContext.Provider>;
};

export const useFieldRefContext = () => {
  const context = useContext(FieldRefContext);
  if (!context) {
    throw new Error('useFieldRefContext must be used within a FieldRefProvider');
  }
  return context;
};
